import { render, staticRenderFns } from "./IncomeCategoryDefault.vue?vue&type=template&id=226a06eb&scoped=true&"
import script from "./IncomeCategoryDefault.vue?vue&type=script&lang=js&"
export * from "./IncomeCategoryDefault.vue?vue&type=script&lang=js&"
import style0 from "./IncomeCategoryDefault.vue?vue&type=style&index=0&id=226a06eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226a06eb",
  null
  
)

export default component.exports